export enum ReportSources {
    DDB = "DDB",
    S3 = "S3",
}
